import { createToastInterface, TYPE } from 'vue-toastification'
import McToastAlert from '@/components/McToastAlert/McToastAlert'
import McToastNotif from '@/components/McToastAlert/McToastNotif'
import McToastDynamicBody from '@/components/McToastAlert/McToastDynamicBody'
import McToastNotifDynamicBody from '@/components/McToastAlert/McToastNotifDynamicBody'
import McToastAlertCloseButton from '@/components/McToastAlert/McToastAlertCloseButton'
import McToastNotifCloseButton from '@/components/McToastAlert/McToastNotifCloseButton'

export const mcToastOptions = {
  component: McToastAlert,
  closeButton: McToastAlertCloseButton,
  toastClassName: 'mc-toast-alert',
  closeButtonClassName: 'mc-toast-alert-close-button',
  hideProgressBar: true,
  timeout: 3000,
  toastDefaults: {
    [TYPE.SUCCESS]: {
      toastClassName: ['mc-toast-alert', 'mc-toast-alert--success'],
      icon: {
        iconClass: 'mc-toast-alert-icon icon-fill_checkmark-circle',
      },
    },
    [TYPE.INFO]: {
      toastClassName: ['mc-toast-alert', 'mc-toast-alert--info'],
      icon: {
        iconClass: 'mc-toast-alert-icon icon-fill_info',
      },
    },
    [TYPE.WARNING]: {
      toastClassName: ['mc-toast-alert', 'mc-toast-alert--warning'],
      icon: {
        iconClass: 'mc-toast-alert-icon icon-fill_alert-triangle',
      },
    },
    [TYPE.ERROR]: {
      toastClassName: ['mc-toast-alert', 'mc-toast-alert--error'],
      icon: {
        iconClass: 'mc-toast-alert-icon icon-fill_slash',
      },
    },
  },
}

export const mcToastNotifOptions = {
  component: McToastNotif,
  closeButton: McToastNotifCloseButton,
  toastClassName: 'mc-toast-notif',
  closeButtonClassName: 'mc-toast-notif-close-button',
  hideProgressBar: true,
  timeout: 10000,
  toastDefaults: {
    [TYPE.DEFAULT]: {
      toastClassName: ['mc-toast-notif', 'mc-toast-notif--success'],
      icon: {
        iconClass: 'd-none mc-toast-notif-icon icon-fill_checkmark-circle',
      },
    },
  },
}

export const mcToast = createToastInterface(mcToastOptions)
export const mcToastNotif = createToastInterface(mcToastNotifOptions)

import Vuex from 'vuex'
import modules from '../state/modules'

export default {
  install(Vue) {
    Vue.use(Vuex)
    const store = new Vuex.Store({
      modules,
      namespaced: true,
      strict: false,
    })
    Vue.prototype.$mcToast = mcToast
    Vue.prototype.$mcToastNotif = mcToastNotif
    Vue.prototype.$store = store // tambahkan ini
    Vue.component('McToastDynamicBody', McToastDynamicBody)
    Vue.component('McToastNotifDynamicBody', McToastNotifDynamicBody)
  },
}
